import { GridColumnMenuProps } from '@mui/x-data-grid-pro';
import React from 'react';
import StyledDataGridMenu from '../DocTable/Styled/StyledDataGridMenu';
import CustomFilterItem from '../DocTable/CustomFilters/CustomFilterItem';
export default (props: GridColumnMenuProps) => {
    const { tableFor, ...rest } = props;
    return (
        <StyledDataGridMenu
            {...rest}
            slots={{
                columnMenuFilterItem: tableFor === 'searchResults' ? CustomFilterItem : null,
                columnMenuColumnsItem: null,
            }}
        />
    );
};
